import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { CustomerPlansSystemModulesComponent } from './customer-plans-system-modules.component';
import { MatTableModule } from '@angular/material/table';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    CustomerPlansSystemModulesComponent
  ],
  imports: [
    CommonModule,
    DialogContainerModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    FlexLayoutModule,
    MatTableModule,
    MatGridListModule,
    MatTooltipModule
  ]
})
export class CustomerPlansSystemModulesModule { }
